export default __webpack_public_path__ + "static/media/loading.d3fbaf2b.gif";